import { graphql } from "react-relay";

// components
import "./EmailTriageGoal.gql";
import "./FocusTimeGoal.gql";
import "./MeetingReliefGoal.gql";
import "./TravelTimeGoal.gql";

export const fragments = {
  org: graphql`
    fragment GoalsWrapper_org on Org {
      ...EmailTriageGoal_org
      ...FocusTimeGoal_org
      ...MeetingReliefGoal_org
      userGoals(first: 1000000) {
        edges {
          node {
            id
            goalId
            name
            isDeleted
          }
        }
      }
    }
  `,
};
